import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";
import helpersTimes from "../../../../../helpers/time";
import validationsFormsAddGift from "../../../../../validtions/forms/gift/add";

export default function ViewLogEditGift() {
  const [logEditGift, setLogEditGift] = useState();
  const params = useParams();
  const logID = params.logID;

  useEffect(() => {
    getLogEditGift();
  }, []);

  const getLogEditGift = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGift = await sendRequestGetLogEditGift();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetGift) {
      return;
    }
    setLogEditGift(resultSendRequestGetGift);
  };

  const sendRequestGetLogEditGift = async () => {
    let headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/gift/manage/log-edit/" + logID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateLogEdit = () => {
    return (
      <div className="table-responsive pt-2">
        <table className="table table-hilite tbl-td-white-space table-hover m-0">
          <thead>
            <tr>
              <td
                colSpan={2}
                className="text-center"
                style={{ borderRadius: "25px 25px 0 0" }}
              >
                <b>اطلاعات لاگ</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <label className="pl-1"> شماره لاگ : </label>
              </td>
              <td>{logEditGift.log_id}</td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> حداقل مبلغ قبل : </label>
              </td>
              <td className="number-finance">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    logEditGift.log_min_amount_before
                  )
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> حداقل مبلغ بعد : </label>
              </td>
              <td className="number-finance">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    logEditGift.log_min_amount_after
                  )
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> حداکثر مبلغ قبل : </label>
              </td>
              <td className="number-finance">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    logEditGift.log_max_amount_before
                  )
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> حداکثر مبلغ بعد : </label>
              </td>
              <td className="number-finance">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    logEditGift.log_max_amount_after
                  )
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> درصد قبل: </label>
              </td>
              <td className="number-finance">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    logEditGift.log_percent_before
                  )
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> درصد بعد: </label>
              </td>
              <td className="number-finance">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    logEditGift.log_percent_after
                  )
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> فعال قبل: </label>
              </td>
              <td>
                {logEditGift.log_active_before ? (
                  <span className="badge badge-success">فعال</span>
                ) : (
                  <span className="badge badge-danger">غیر فعال</span>
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> فعال بعد: </label>
              </td>
              <td>
                {logEditGift.log_active_after ? (
                  <span className="badge badge-success">فعال</span>
                ) : (
                  <span className="badge badge-danger">غیر فعال</span>
                )}
              </td>
            </tr>
            <tr>
              <td>
                <label className="pl-1"> تاریخ درج : </label>
              </td>
              <td>
                {helpersNumbers.toPersianNum(
                  helpersTimes.convertGregorianToJalali(
                    logEditGift.log_created_at
                  ) +
                    " " +
                    logEditGift.log_created_at.split(" ")[1]
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">اضافه کردن هدیه</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to={`/finance/manage/gift/log/${logEditGift?.log_gift_id}`}
                  className="btn btn-primary"
                >
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {logEditGift && generateLogEdit()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
